<template>
  <div>
    <v-text-field v-model="date"
                  :rules="computedRules"
                  :label="label"
                  hint="MM/DD/YYYY"
                  append-outer-icon="event"
                  clearable
                  @click:append-outer="dateMenu = !dateMenu" />
    <v-dialog v-model="dateMenu" width="290px">
      <v-date-picker v-model="isoDate" />
    </v-dialog>
  </div>
</template>

<script>
  const checkValidDate = (val) => val === '' || val == null || /(0?\d|1[012])[-/](0?\d|[12]\d|3[01])[-/](19|20)\d\d/.test(val);

  export default {
    props: ['value', 'label', 'rules'],
    data: () => ({
      dateMenu: false
    }),
    computed: {
      date: {
        get() {
          return this.value ? new Date(`${this.value.substring(0, 10)} 00:00`).toLocaleDateString('en-us') : '';
        },
        set(val) {
          this.dateMenu = false;
          if (checkValidDate(val)) {
            if (!val) {
              this.$emit('input', '');
            } else {
              this.$emit('input', new Date(val).toISOString().substring(0, 10));
            }
          }
        }
      },
      isoDate: {
        get() {
          return this.value ? this.value.substring(0, 10) : '';
        },
        set(val) {
          this.dateMenu = false;
          if (!val) {
            this.$emit('input', '');
          } else {
            this.$emit('input', val);
          }
        }
      },
      computedRules() {
        const rulesProp = (this.rules && this.rules.length) ? this.rules : [];
        return [...rulesProp, v => checkValidDate(v) || 'Must be a valid date'];
      },
      today() {
        return new Date().toISOString().substring(0, 10);
      }
    }
  }
</script>
